import { FormSuccessStepApply } from 'components/common/form'
/**
 *
 * @description Success component for the artist-apply form.
 *
 */
const ArtistFormSuccess = () => <FormSuccessStepApply />

export default ArtistFormSuccess
